import React, { useEffect, useState, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";
import moment from "moment";
import QRCode from "qrcode";
import Drawer from "@mui/material/Drawer";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Sidebar from "../../components/Sidebar";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import { alertMessage } from "../../actions/auth";
import { Bar } from "react-chartjs-2";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import TextField from "@mui/material/TextField";
import Avatar from "@mui/material/Avatar";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import { Chart } from "chart.js/auto";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Fab } from "@mui/material";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Checkbox from "@mui/material/Checkbox";
import DownloadIcon from "@mui/icons-material/Download";
import QrCodeIcon from "@mui/icons-material/QrCode";
import PublishIcon from "@mui/icons-material/Publish";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import CloseIcon from "@mui/icons-material/Close";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import EditIcon from "@mui/icons-material/Edit";
import UploadIcon from "@mui/icons-material/Upload";
import { API_URL } from "../../actions/auth";
import { themeStyle } from "../../components/Components";
import AddIcon from "@mui/icons-material/Add";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material";
import { CloudUpload, Description, Close } from "@mui/icons-material";

const Dropzone = styled("div")(({ theme }) => ({
  border: `2px dashed ` + themeStyle.primaryColor,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(6),
  textAlign: "center",
  cursor: "pointer",
}));

const FileUploadCard = () => {
  return (
    <Box sx={{ maxWidth: 400, mx: "auto", marginBottom: "50px" }} elevation={1}>
      <Dropzone>
        <CloudUpload
          fontSize="large"
          sx={{ color: themeStyle.primaryColor, mb: 1, fontSize: "50px" }}
        />
        <Typography variant="body1">Click here to upload your file</Typography>
        <Typography variant="caption" color="text.secondary">
          with .xlsx file extension (Max 25MB)
        </Typography>
      </Dropzone>
    </Box>
  );
};

function Inventory() {
  const dispatch = useDispatch();
  function createAlert(type, title, message) {
    dispatch(alertMessage(type, title, message));
  }
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const state = useSelector((state) => state);
  const [isLoading, setIsLoading] = useState(true);
  const [imgError, setImgError] = useState(false);
  const [ogInventory, setOGInventory] = useState([]);
  const [random, setRandom] = useState(0);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [search, setSearch] = useState("");
  const [product, setProduct] = useState({});
  const [open, setOpen] = useState(false);
  const [isUploading, setIsUploading] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [inventoryList, setInventoryList] = useState([]);
  const [toggleDrawer, setToggleDrawer] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [select, setSelect] = useState("Electronics");
  const [inventoryName, setInventoryName] = useState("");
  const [minimum, setMinimum] = useState("");
  const [inventoryDescription, setInventoryDescription] = useState("");
  const [quantity, setQuantity] = useState("");
  const [rate, setRate] = useState("");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [isPerishable, setIsPerishable] = useState(false);
  const [stock, setStock] = useState("");

  function handleSearch(text) {
    setSearch(text);
    if (text.length == 0) {
      setInventoryList(ogInventory);
      setSearch("");
      setRandom(makeid(5));
    } else {
      var tempStudents = [];

      for (var i = 0; i < ogInventory.length; i++) {
        if (
          ogInventory[i]["name"].toLowerCase().includes(text.toLowerCase()) ||
          ogInventory[i]["category"].toLowerCase().includes(text.toLowerCase())
        ) {
          tempStudents.push(ogInventory[i]);
        }
      }
      setCurrentPage(1);
      setInventoryList(tempStudents);
      setRandom(makeid(5));
    }
  }

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  function handleCurrentPage(val) {
    var tempStudents = Array.from(ogInventory);
    setSearch("");
    setCurrentPage(val);
    setInventoryList(tempStudents.splice((val - 1) * 25, 25));
  }

  function getInventory() {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,

        "Content-Type": "application/json",
      },
    };

    body["institution_id"] = state.auth.user.institution_id;
    body["user_id"] = state.auth.user.user_id;
    body = JSON.stringify(body);

    axios
      .post(API_URL + "/get_inventory", body, config)
      .then((res) => {
        setProduct(res.data["inventory"][0]);
        setImgError(false);
        setOGInventory(res.data["inventory"]);
        setInventoryList(res.data["inventory"]);
        setRandom(makeid(4));
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
      });
  }

  useEffect(() => {
    if (state.auth.isLoading) {
      dispatch({ type: "ENTRY_PAGE", payload: window.location.pathname });
      navigate("/", { replace: true });
    } else {
      getInventory();
    }
  }, []);

  function getContent() {
    return (
      <div>
        {inventoryList.length == 0 ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "40px",
            }}
          >
            <SearchOffIcon
              style={{
                fontSize: "200px",
                marginBottom: "20px",
                color: themeStyle.primaryColor,
              }}
            />
            <Typography variant="h6" style={{ color: themeStyle.primaryColor }}>
              No inventory found in records
            </Typography>
          </div>
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                padding: "25px",
              }}
            >
              <Grid container spacing={3} justifyContent={"flex-end"}>
                <Grid item md={4}>
                  <div
                    style={{
                      backgroundColor: themeStyle.primaryCardColor,
                      borderRadius: "15px",
                      padding: "15px",
                      height: "100%",
                    }}
                  >
                    {imgError ? (
                      <div
                        style={{
                          maxWidth: "100%",
                          borderRadius: "15px",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          style={{ height: "200px" }}
                          src={require("../../img/inventory.png")}
                        />
                      </div>
                    ) : (
                      <img
                        style={{ maxWidth: "100%", borderRadius: "15px" }}
                        src={API_URL + "/media/" + product.inv_id + ".jpg"}
                        onError={() => {
                          setImgError(true);
                        }}
                      />
                    )}
                    <div
                      style={{
                        color: themeStyle.primaryColor,
                        fontSize: "25px",
                        fontWeight: "bold",
                      }}
                    >
                      {product.name}
                    </div>
                    <div
                      style={{
                        color: "black",
                        fontSize: "20px",
                      }}
                    >
                      {product.description}
                    </div>
                    <br />
                    <span
                      style={{
                        fontSize: "20px",
                        color: themeStyle.secondaryColor,
                        fontWeight: "bold",
                      }}
                    >
                      Inventory Information
                    </span>
                    <hr />

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span>Inventory Id:</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {product.inv_id ? (
                          product.inv_id
                        ) : (
                          <span style={{ color: "#ff3333" }}>
                            NOT AVAILABLE
                          </span>
                        )}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span>Category:</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {product.category ? (
                          product.category
                        ) : (
                          <span style={{ color: "#ff3333" }}>
                            NOT AVAILABLE
                          </span>
                        )}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span>Quantity:</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {product.quantity ? (
                          product.quantity
                        ) : (
                          <span style={{ color: "#ff3333" }}>
                            NOT AVAILABLE
                          </span>
                        )}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span>Rate:</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {product.rate ? (
                          product.rate + " per unit"
                        ) : (
                          <span style={{ color: "#ff3333" }}>
                            NOT AVAILABLE
                          </span>
                        )}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span>Total Price:</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {product.total_price ? (
                          product.total_price
                        ) : (
                          <span style={{ color: "#ff3333" }}>
                            NOT AVAILABLE
                          </span>
                        )}
                      </span>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span>Perishable</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {!product.is_perishable ? (
                          "NO"
                        ) : (
                          <span style={{ color: "#ff3333" }}>YES</span>
                        )}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span>Expiry Date</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {product.expiry ? product.expiry : "NON PERISHABLE"}
                      </span>
                    </div>
                    <br />
                    <span
                      style={{
                        fontSize: "20px",
                        color: themeStyle.secondaryColor,
                        fontWeight: "bold",
                      }}
                    >
                      Activity
                    </span>
                    <Grid
                      container
                      spacing={2}
                      style={{
                        justifyContent: "flex-start",
                        textAlign: "left",
                        marginTop: "15px",
                        marginLeft: "0px",
                        paddingBottom: "15px",
                        color: themeStyle.primaryColorLight,
                        borderBottom: "1px solid" + themeStyle.primaryColor,
                        backgroundColor: themeStyle.secondaryColor,
                        width: "100%",
                        borderTopRightRadius: "15px",
                        borderTopLeftRadius: "15px",
                      }}
                    >
                      <Grid item md={3}>
                        Sr
                      </Grid>
                      <Grid item md={3}>
                        Date
                      </Grid>
                      <Grid item md={3}>
                        Type
                      </Grid>
                      <Grid item md={3}>
                        Value
                      </Grid>
                    </Grid>

                    <div
                      style={{
                        color: themeStyle.primaryColor,
                        marginLeft: "15px",
                      }}
                    >
                      {product.activity ? (
                        JSON.parse(product.activity).map((activity, index) => {
                          return (
                            <Grid container spacing={2}>
                              <Grid item md={3}>
                                {index + 1}
                              </Grid>
                              <Grid item md={3}>
                                {activity.date}
                              </Grid>
                              <Grid item md={3}>
                                {" "}
                                <div
                                  style={{
                                    color:
                                      activity.type == "ADD" ? "green" : "red",
                                  }}
                                >
                                  {activity.type}
                                </div>
                              </Grid>
                              <Grid item md={3}>
                                {activity.value}
                              </Grid>
                            </Grid>
                          );
                        })
                      ) : (
                        <span style={{ color: "#ff3333" }}>NOT AVAILABLE</span>
                      )}
                    </div>
                    <hr />
                    <Grid container spacing={2}>
                      <Grid item md={3}></Grid>
                      <Grid item md={3}></Grid>
                      <Grid item md={3}>
                        CURRENT
                      </Grid>
                      <Grid item md={3}>
                        {" "}
                        {product.stock ? (
                          product.stock
                        ) : (
                          <span style={{ color: "#ff3333" }}>
                            NOT AVAILABLE
                          </span>
                        )}
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
                <Grid item md={8}>
                  <div
                    style={{
                      border: "3px solid " + themeStyle.primaryCardColor,
                      borderRadius: "15px",
                      padding: "15px",
                    }}
                  >
                    <Grid
                      container
                      spacing={2}
                      style={{
                        justifyContent: "flex-start",
                        textAlign: "left",
                        paddingBottom: "15px",
                        color: themeStyle.primaryColor,
                        borderBottom: "1px solid" + themeStyle.primaryColor,
                        backgroundColor: themeStyle.primaryCardColor,
                        width: "103.2%",
                        borderTopRightRadius: "15px",
                        borderTopLeftRadius: "15px",
                      }}
                    >
                      <Grid item md={1}>
                        Sr
                      </Grid>
                      <Grid item md={3}>
                        Inventory Name
                      </Grid>
                      <Grid item md={3}>
                        Category
                      </Grid>
                      <Grid item md={3} style={{ textAlign: "center" }}>
                        Quantity
                      </Grid>
                      <Grid item md={2} style={{ textAlign: "center" }}>
                        Expiry
                      </Grid>
                    </Grid>
                    {inventoryList.map((product, index) => (
                      <Grid
                        onClick={() => {
                          setProduct(product);
                          setImgError(false);
                        }}
                        container
                        spacing={2}
                        style={{
                          color: "black",
                          padding: "15px",
                        }}
                      >
                        <Grid item md={1}>
                          {index + 1}
                        </Grid>
                        <Grid
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setProduct(product);
                            setImgError(false);
                          }}
                          item
                          md={3}
                        >
                          {product["name"]}
                        </Grid>
                        <Grid
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setProduct(product);
                            setImgError(false);
                          }}
                          item
                          md={3}
                        >
                          {product["category"]}
                        </Grid>
                        <Grid item md={3} style={{ textAlign: "center" }}>
                          {product["quantity"]}
                        </Grid>
                        <Grid item md={2} style={{ textAlign: "center" }}>
                          {product["expiry"]}
                        </Grid>
                      </Grid>
                    ))}
                  </div>
                  {inventoryList.length > 15 ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginBottom: "-15px",
                        marginTop: "-15px",
                      }}
                    >
                      {Array.from(
                        Array(Math.ceil(ogInventory.length / 25)).keys()
                      ).map((temp, index) => (
                        <div
                          style={{
                            cursor: "pointer",
                            margin: "3px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "25px",
                            height: "25px",
                            borderRadius: "30px",
                            color: "white",
                            backgroundColor: themeStyle.primaryColor,
                          }}
                          onClick={() => {
                            handleCurrentPage(index + 1);
                          }}
                        >
                          {index + 1}
                        </div>
                      ))}
                    </div>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
            </div>
          </div>
        )}
      </div>
    );
  }

  if (!state.auth.isLoading) {
    if (state.auth.isAuthenticated) {
      if (state.auth.user.is_principal) {
        if (isLoading) {
          return (
            <Fragment>
              <Sidebar />
              <div
                style={{
                  maxWidth: "88vw",
                  marginTop: "45vh",
                  marginLeft: "8vw",
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <CircularProgress />
              </div>
            </Fragment>
          );
        } else {
          return (
            <Fragment>
              <Sidebar
                tabs={
                  <Grid container spacing={1.5}>
                    <Grid item md={3}>
                      {/* <Select
                      value={classs}
                      onChange={(e) => handleClassChange(e)}
                      style={{
                        height: "40px",
                        marginTop: "2px",
                      }}
                      fullWidth
                      variant={"outlined"}
                    >
                      {getClassList()}
                    </Select> */}
                    </Grid>
                    <Grid item md={3}>
                      {/* <Select
                      value={division}
                      onChange={(e) => handleDivisionChange(e)}
                      style={{
                        height: "40px",
                        marginTop: "2px",
                      }}
                      fullWidth
                      variant={"outlined"}
                    >
                      {getDivisionList()}
                    </Select> */}
                    </Grid>
                    <Grid item md={6}>
                      <TextField
                        fullWidth
                        id="outlined-basic"
                        placeholder="Search Inventory"
                        variant="outlined"
                        value={search}
                        size="small"
                        style={{
                          height: "40px",
                          marginTop: "2px",
                        }}
                        onChange={(e) => handleSearch(e.target.value)}
                      />
                    </Grid>
                  </Grid>
                }
              />

              <div
                style={{
                  margin: "45px 0px 20px 70px",
                  backgroundColor: "white",
                }}
              >
                {getContent()}
              </div>
            </Fragment>
          );
        }
      } else {
        dispatch({ type: "AUTH_ERROR" });
      }
    } else {
      dispatch({ type: "AUTH_ERROR" });
    }
  } else {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          marginTop: "46vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }
}

export default Inventory;
